const dictionary = {
  en: {
    messages: {
      alpha: function (n) {
        return "The field can contain only letters."
      },
      'emailMethod': function (n) {
        return "The field must be a valid email address."
      },
      'email': function (n) {
        return "The field must be a valid email address."
      },
      numeric: function (n) {
        return "The field must be a number."
      },
      'alpha_numeric_symbols': function (n) {
        return "The field has an invalid format."
      },
      required: function (n) {
        return "This field is required."
      },
      '_default': function (n) {
        return "The field has an invalid format."
      },
      'username': function (n) {
        return "The field has an invalid format."
      },
      'numeric_method': function (n) {
        return "The field must be a number."
      },
      max: function (n, e) {
        return `The field cannot contain more then ${e.length} symbols.`
      },
      min: function (n, e) {
        return `The field must contain at least ${e.length} symbols.`
      },
      'max_value': function (n, e) {
        return `Value must not exceed ${e}.`
      },
      'min_value': function (n, e) {
        return `The value must not be less than ${e}.`
      },
      phoneNumber: function (n, e) {
        return "Enter correct phone number."
      },
      passwordMethod: function (n, e) {
        return "Enter a more complex password."
      },
      ukPhone(n) {
        return "Wrong format."
      },
      oneHour(n) {
        return "Time must be at least one hour more than now."
      }
    },
  },
}

export { dictionary }



// WEBPACK FOOTER //
// ./src/js/validation/constants.js